import React, { useEffect, useState } from "react";
import { Table, Button, Input, Space, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import CreateUserLoginForm from "./Createuserloginform";
import actions from "../../../redux/createAiCredential/action"; // ✅ correct action file
import UpdateAiDetailsForm from "./UpdateAiDetailsForm";
import decryptedModulesData from "../../../utils/decryptedModules";

const CreateuserLogin = ({ role }) => {
  const { modules: permissions } = decryptedModulesData();
  const [searchText, setSearchText] = useState("");
  const [visible, setVisible] = useState(false);
  const [updateFormVisible, setUpdateFormVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();

  const { aiCredentials = [], loading } = useSelector(
    (state) => state?.createAiCredentialReducer || {}
  );

  const agentDetailsPermission =
    (Array.isArray(permissions) &&
      permissions?.find(
        (perm) => perm.module.toLowerCase() === "agent details"
      )) ||
    {};
  const canCreate = agentDetailsPermission?.create ?? false;
  const canUpdate = agentDetailsPermission?.update ?? false;

  //console.log("this is ai credential", aiCredentials);

  useEffect(() => {
    dispatch(actions.getAllAICredentialData());
  }, [dispatch]);

  const filteredData = (aiCredentials || [])
    .filter((user) => user && user.isBankUser === false) // ✅ only non-bank users
    .filter(
      (user) =>
        user.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        user.email?.toLowerCase().includes(searchText.toLowerCase()) ||
        user.roleId?.role?.toLowerCase().includes(searchText.toLowerCase()) ||
        user.orgId?.toLowerCase().includes(searchText.toLowerCase()) // updated to use role from populated object
    )
    .reverse();

  const tableData = filteredData
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // newest first
    .map((user, index) => ({
      key: index + 1,
      ...user,
      role: user.roleId?.role || "-", // Get role from populated object
      createdAt: user.createdAt
        ? new Date(user.createdAt).toLocaleString()
        : "-",
      updatedAt: user.updatedAt
        ? new Date(user.updatedAt).toLocaleString()
        : "-",
    }));

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      width: 50,
    },
    {
      title: "Agent ID",
      dataIndex: "orgId",
      key: "orgId",
    },
    {
      title: "Ainame",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },

    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
    },

    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          {/* <Button
            type="link"
            icon={<span role="img" aria-label="edit">✏️</span>}
            style={{ padding: 0 }}
            onClick={() => {
              setEditingRecord(record);
              setUpdateFormVisible(true);
            }}
          /> */}
          <Button
            type="link"
            icon={
              <span role="img" aria-label="edit">
                ✏️
              </span>
            }
            style={{
              padding: 0,
              opacity: canUpdate ? 1 : 0.5,
              cursor: canUpdate ? "pointer" : "not-allowed",
            }}
            disabled={!canUpdate}
            onClick={() => {
              if (canUpdate) {
                setEditingRecord(record);
                setUpdateFormVisible(true);
              }
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <div className="mainContain">
      {contextHolder}
      <div className="d-flex justify-content-between align-items-center mb-3">
        {/* <Button
          type="primary"
          size="large"
          onClick={() => {
            setEditingRecord(null);
            setVisible(true);
          }}
          style={{
            backgroundColor: "#073763",
            borderColor: "#073763",
          }}
        >
          Add AI Credential
        </Button> */}
        <Button
          type="primary"
          size="large"
          onClick={() => {
            if (canCreate) {
              setEditingRecord(null);
              setVisible(true);
            }
          }}
          style={{
            backgroundColor: "#073763",
            borderColor: "#073763",
            color: "white",
            opacity: canCreate ? 1 : 0.6,
            cursor: canCreate ? "pointer" : "not-allowed",
          }}
          disabled={!canCreate}
        >
          Add AI Credential
        </Button>
        <Input
          placeholder="Search by username, email, role"
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          allowClear
          style={{ width: 300 }}
        />
      </div>

      <Table
        columns={columns}
        dataSource={tableData}
        loading={loading}
        bordered
        rowKey="_id"
        scroll={{ x: true }}
        pagination={{
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "100"],
          defaultPageSize: 100,
        }}
      />

      <CreateUserLoginForm
        visible={visible}
        onCancel={() => {
          setEditingRecord(null);
          setVisible(false);
        }}
        setVisible={setVisible}
        loading={loading}
      />

      <UpdateAiDetailsForm
        visible={updateFormVisible}
        onCancel={() => {
          setEditingRecord(null);
          setUpdateFormVisible(false);
        }}
        editingRecord={editingRecord}
      />
    </div>
  );
};

export default CreateuserLogin;
